/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FacilityDashboardInfoResponse { 
    facilityId: string;
    facilityName: string;
    workingCount: number;
    freeCount: number;
    underRepairCount: number;
    offlineCount: number;
}

